import React from 'react';
import {
  Button,
  Col,
  Form,
  Input,
  InputNumber,
  Modal,
  notification,
  Row,
} from 'antd';
import { useMutation } from '@tanstack/react-query';
import { IProductAddStockReq } from '@/interfaces/product';
import { addStockProduct } from '@/adapters/product';

interface IProps {
  open: boolean;
  productId: number;
  handleOk: () => void;
  handleCancel: () => void;
}

const ProductAddStockModal = ({
  open,
  productId,
  handleOk,
  handleCancel,
}: IProps) => {
  const [form] = Form.useForm<IProductAddStockReq>();
  const mutations = useMutation({
    mutationFn: async (data: IProductAddStockReq) =>
      await addStockProduct(data),
    mutationKey: ['actionProduct'],
    onSuccess: data => {
      if (data?.status != 200) {
        throw new Error();
      } else {
        const message = 'เติมสต็อกสำเร็จ';
        notification.success({
          message: message,
        });
        handleOk();
      }
    },
    onError: error => {
      console.log(error);
    },
  });

  const handleUpdate = async () => {
    form
      .validateFields()
      .then(async (values: IProductAddStockReq) => {
        values.productId = productId;
        mutations.mutateAsync(values);
      })
      .catch(info => {
        console.log('Validate Failed:', info);
      });
  };

  const onReset = () => {
    form.resetFields();
  };

  return (
    <Modal
      title={'เติมสต็อก'}
      open={open}
      onOk={() => handleUpdate()}
      onCancel={handleCancel}
      okText="บันทึก"
      cancelText="ยกเลิก"
      footer={[
        <Button key="back" onClick={handleCancel}>
          ยกเลิก
        </Button>,
        <Button
          key="submit"
          type="primary"
          form="productGroup"
          loading={mutations.isPending}
          onClick={handleUpdate}
        >
          บันทึก
        </Button>,
      ]}
      afterClose={onReset}
    >
      <div className="flex w-full">
        <Form
          form={form}
          name="add-product-stock"
          onFinish={handleUpdate}
          layout="vertical"
          className="w-full"
        >
          <Row gutter={12}>
            <Col span={24}>
              <Form.Item
                label="จำนวนที่เติมสต็อก"
                name="quantity"
                rules={[{ required: true, message: 'จำนวนที่เติมสต็อก' }]}
              >
                <InputNumber min={1} size="large" className="w-full" />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item label="บันทึกช่วยจำ" name="remark">
                <Input.TextArea rows={3} />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </div>
    </Modal>
  );
};

export default ProductAddStockModal;
